'use strict';

var React = require('react');

var SvgGiftCardFilledMinor = function SvgGiftCardFilledMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 9.125h.75a.375.375 0 1 0-.3-.6l-.45.6zm-3.25 0h.75l-.45-.6a.375.375 0 1 0-.3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.375 4.5h-3.875a2 2 0 0 0-2 2v2.625h1.5a.625.625 0 1 1 0 1.25h-1.5v3.125a2 2 0 0 0 2 2h3.875v-1.75a.625.625 0 1 1 1.25 0v1.75h5.875a2 2 0 0 0 2-2v-3.125h-3.5a.625.625 0 1 1 0-1.25h3.5v-2.625a2 2 0 0 0-2-2h-5.875v1.25a.625.625 0 1 1-1.25 0v-1.25zm1.325 3.275a1.625 1.625 0 1 1 1.3 2.6h-.79c.032.038.065.076.1.114.503.563 1.127 1.05 1.778 1.142a.625.625 0 0 1-.176 1.238c-1.1-.157-1.975-.921-2.534-1.546a7.831 7.831 0 0 1-.378-.457c-.11.145-.237.3-.378.457-.56.625-1.435 1.389-2.534 1.546a.625.625 0 1 1-.176-1.238c.65-.093 1.275-.579 1.778-1.142.035-.038.068-.076.1-.114h-.79a1.625 1.625 0 1 1 1.3-2.6v-.002l.608.813.092.122.092-.122.607-.813.001.002z"
  }));
};
SvgGiftCardFilledMinor.displayName = "GiftCardFilledMinor";

exports.SvgGiftCardFilledMinor = SvgGiftCardFilledMinor;
